import { render, staticRenderFns } from "./RecipientsInfo.vue?vue&type=template&id=4bfb5de8"
import script from "./RecipientsInfo.vue?vue&type=script&lang=js"
export * from "./RecipientsInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports